<template>
  <div class="page-content users-table-view" style="height: 100vh;">
    <div class="container-fluid bracket-custom-style">
      <Card class="header-card">
        <Row>
          <Col span="16">
          <span class="page-title">{{ $t('user.page_title') }}</span>
          <Select v-model="tableLenght" style="width: 70px" :placeholder="$t('global.kiezen')">
            <Option value="10">10</Option>
            <Option value="25">25</Option>
            <Option value="50">50</Option>
            <Option value="100">100</Option>
          </Select>
          <Button class="md-checkmark-style" @click="switchBanned()"
            :icon="showBanned ? 'md-checkmark-circle' : 'md-checkmark-circle-outline'">
            {{ $t('user.table.show_banned') }}: <b v-if="!showBanned">{{ banned.length }}</b> <b v-else>{{ users.length
            }}</b>
          </Button>
          <Button class="md-checkmark-style" v-if="birthdays > 0" @click="switchBirthday()"
            :icon="showBirthday ? 'md-checkmark-circle' : 'md-checkmark-circle-outline'">
            {{ $t('user.table.birthday_soon') }}: <b>{{ birthdays }}</b>
          </Button>
          </Col>
          <Col span="8" class="d-flex justify-content-end">
          <Button class="mr-2" type="warning" @click="modalDriver = true"><b>{{ $t('user.table.add_user') }}</b></Button>
          <UserForm v-if="modalDriver" @updateList="getUsers()" :user="userSelected" :roles="roles"
            @close="() => { this.userSelected = null; this.modalDriver = false }" />

          </Col>
        </Row>
      </Card>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Row style="margin-top: 20px" v-if="enableFor(['admin', 'super'])">
        <Col span="24">
        <div class="card">
          <div class="card-body-table">
            <table id="users-table" class="table table-bordered dt-responsive table-striped nowrap">
              <thead class="positionThead">
                <tr>
                  <th style="width: 75px; min-width: 75px; max-width: 75px; padding: 4px;"></th>
                  <th style="width: 217px; min-width: 217px; max-width: 217px; padding: 4px;"
                    @click="sortColumn = 'name'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('user.table.name_surname') }}
                      <div v-if="sortColumn === 'name'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th>
                  <th style="width: 150px; min-width: 150px; max-width: 150px; padding: 4px;"
                    @click="sortColumn = 'role'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('user.table.role') }}
                      <div v-if="sortColumn === 'role'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th>
                  <th style="width: 217px; min-width: 217px; max-width: 217px; padding: 4px;"
                    @click="sortColumn = 'clubSearch'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('club.club') }}
                      <div v-if="sortColumn === 'clubSearch'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th>
                  <!-- <th style="width: 140px; min-width: 140px; max-width: 140px; padding: 4px;"
                    @click="sortColumn = 'phone'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('user.table.phone') }}
                      <div v-if="sortColumn === 'phone'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th>
                  <th style="width: 220px; min-width: 220px; max-width: 220px; padding: 4px;"
                    @click="sortColumn = 'iban'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('user.table.iban') }}
                      <div v-if="sortColumn === 'iban'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th> -->
                  <!--                    <th style="width: 70px; min-width: 70px; max-width: 70px; padding: 4px;">-->
                  <!--                      {{$t('user.table.status')}}-->
                  <!--                    </th>-->
                  <!-- <th style="width: 125px; min-width: 125px; max-width: 125px; padding: 4px;"
                    @click="sortColumn = 'visaExpiryDisplay'">
                    <div class="d-flex align-items-center justify-content-between">
                      {{ $t('user.table.visa_until') }}
                      <div v-if="sortColumn === 'visaExpiryDisplay'" class="sort-by" @click="sortBy()">
                        <div v-if="sortByValue === 'asc'">
                          <Icon type="md-arrow-round-up" />
                        </div>
                        <div v-else>
                          <Icon type="md-arrow-round-down" />
                        </div>
                      </div>
                      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
                    </div>
                  </th> -->
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <Input v-model="search.name" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.roleSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.clubSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <!-- <th>
                    <Input v-model="search.phoneSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.iban" :placeholder="$t('global.search')" clearable />
                  </th> -->
                  <!--                    <th></th>-->
                  <!-- <th>
                    <Input v-model="search.visaExpiryDisplay" :placeholder="$t('global.search')" clearable />
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <template v-for="(user, index) in arrayList.data">
                  <tr :key="user._id"
                    :class="{ 'expire': user.soonExpire, 'todayBirthday': user.whenBirthday && user.whenBirthday === 'today' ? true : false, 'tomorrowBirthday': user.whenBirthday && user.whenBirthday === 'tomorrow' ? true : false }">
                    <td class="text-center">
                      <Button @click="openModal(user)" type="dashed" class="user-info-btn"><b>Info</b></Button>
                    </td>

                    <td class="user-style">
                      <Tooltip placement="top-start">
                        <b
                          :class="!user.rating ? '' : user.rating === '0' ? 'good-rating' : user.rating === '1' ? 'average-rating' : user.rating === '2' ? 'black-list-rating' : ''">
                          {{ user.firstName ? user.firstName + " " + user.secondName : user.name }}
                        </b>
                        <div slot="content">
                          <div v-if="user.description">
                            <small>{{ user.firstName ? user.firstName + " " + user.secondName : user.name }}</small>
                            <p>{{ user.description }}</p>
                          </div>
                          <div v-else>{{ user.firstName ? user.firstName + " " + user.secondName : user.name }}</div>
                        </div>
                      </Tooltip>
                    </td>

                    <td>
                      <a v-for="role in user.role" href="#" class="badge badge-soft-primary font-size-11"
                        style="display: inline-block; line-height: 1rem">{{ $t('roles.' + role) }}</a>
                    </td>

                    <td class="user-style">
                      <Tooltip :content="user.clubId ? user.clubId.name : ''" placement="top-start">
                        {{ user.clubId ? user.clubId.name : '' }}
                      </Tooltip>
                    </td>

                    <!-- <td class="user-phone-list">
                      <Tooltip placement="top-start">
                        <div v-if="user.phone">
                          <p v-for="(phone, key) in user.phone" :key="'p' + key"> {{ phone }} </p>
                        </div>
                        <div v-if="user.personalPhone">
                          <p v-for="(phone, key) in user.personalPhone" :key="'p1' + key"> {{ phone }} </p>
                        </div>
                        <div slot="content">
                          <div v-if="user.phone">
                            <p v-for="(phone, key) in user.phone" :key="'p' + key"> {{ phone }} </p>
                          </div>
                          <div v-if="user.personalPhone">
                            <p v-for="(phone, key) in user.personalPhone" :key="'p1' + key"> {{ phone }} </p>
                          </div>
                        </div>
                      </Tooltip>
                    </td>

                    <td class="user-iban-style">
                      <Tooltip :content="user.iban" placement="top-start">
                        {{ user.iban }}
                      </Tooltip>
                      <Button v-if="user.iban && user.iban.length" @click="copy(user)" size="small" shape="circle"
                        icon="ios-copy"></Button>
                    </td> -->

                    <!--                     <td></td>-->

                    <!-- <td class="text-center">{{ user.visaExpiryDisplay }}</td> -->

                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        </Col>
      </Row>
      <Card v-if="enableFor(['admin', 'super'])">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span v-if="arrayFiltered.length">
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }} {{
                $t('global.of') }}
              {{ arrayFiltered.length }} {{ $t('global.entry') }} ({{ $t('global.filtered', { len: array.length }) }})
            </span>
            <span v-else>
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }} {{
                $t('global.of') }} {{ users.length }}
              {{ $t('global.entry') }}
            </span>
          </div>
          <Page @on-change="changePage" v-if="arrayList.total > 0" :current="arrayList.page"
            :page-size="parseInt(tableLenght)" :total="arrayList.total" />
        </div>
      </Card>
    </div>
  </div>
</template>
<script>

import UsersAddFormDriver from "./UsersAddFormDriver.vue";
import UsersAddFormUser from "./UsersAddFormUser.vue";
import UsersStats from "./UsersStats.vue";
import DatePicker from "vue2-datepicker";
import mixin from "../mixinTable.js";
import UserForm from "./UserForm.vue";
import TableaHeadCol from '../helper/table/TableaHeadCol.vue'

export default {
  name: "App",

  components: {
    UsersStats,
    UsersAddFormDriver,
    UsersAddFormUser,
    DatePicker,
    UserForm,
    TableaHeadCol
  },
  mixins: [mixin],
  data() {
    return {
      modalUser: false,
      modalDriver: false,
      showBirthday: false,
      lang: localStorage.getItem("lang") || "de",
      tableLenght: localStorage.getItem("dt.length") || 100,
      loading: false,
      options: {
        shortcuts: [
          {
            text: this.$t('shortcuts.week'),
            onClick: () => {
              let start = this.$moment().startOf('isoWeek').toDate();
              let end = this.$moment().endOf('isoWeek').toDate();
              return [start, end];
            }
          },
          {
            text: this.$t('shortcuts.month'),
            onClick: () => {
              let start = this.$moment().startOf('month').toDate();
              let end = this.$moment().endOf('month').toDate();
              return [start, end];
            }
          },
          {
            text: this.$t('shortcuts.year'),
            onClick: () => {
              let start = this.$moment().startOf('year').toDate();
              let end = this.$moment().endOf('year').toDate();
              return [start, end];
            }
          }
        ]
      },
      roles: [
        {
          role: 'admin',
          title: this.$t('roles.admin')
        },
        {
          role: 'manager',
          title: this.$t('roles.manager')
        },
        {
          role: 'competition_director',
          title: this.$t('roles.competition_director')
        },
        {
          role: 'license_admin',
          title: this.$t('roles.license_admin')
        },
        {
          role: 'super',
          title: this.$t('roles.super')
        },
        // {
        //   role: 'trucker',
        //   title: this.$t('roles.trucker')
        // },
        // {
        //   role: 'monitor',
        //   title: this.$t('roles.monitor')
        // },
        // {
        //   role: 'reestr',
        //   title: this.$t('roles.reestr')
        // },
        // {
        //   role: 'accounting',
        //   title: this.$t('roles.accounting')
        // },
        // {
        //   role: 'chief-accounting',
        //   title: this.$t('roles.chief-accounting')
        // },
        // {
        //   role: 'reestr-monitor',
        //   title: this.$t('roles.reestr-monitor')
        // },
        // {
        //   role: 'palettenabteilung',
        //   title: this.$t('roles.palettenabteilung')
        // },
        // {
        //   role: 'palettenabteilung-admin',
        //   title: this.$t('roles.palettenabteilung-admin')
        // },
        // {
        //   role: 'driver',
        //   title: "Driver"
        // },
        // {
        //   role: 'hr',
        //   title: "HR"
        // }
      ],
      users: [],
      banned: [],
      userBirthday: [],
      arrayFiltered: [],
      arrayList: {
        data: [],
        page: 0,
        per_page: 0,
        pre_page: 0,
        next_page: 0,
        total: 0,
        total_pages: 0,
      },
      userSelected: null,
      isPrint: false,
      showBanned: false,
      filterKeyLength: 0,
    }
  },
  watch: {
    tableLenght(n) {
      localStorage.setItem("dt.length", parseInt(n));
      this.changePage(1);
    },
  },
  computed: {
    birthdays() {
      return this.users.filter((user) => user.soonBirthday === 'show').length
    },
    // clearInput() {
    //   console.log("clear input")
    //   return this.users.filter(user => user.role[0] !== 'super' && !user.banned)
    // },
    // returnBanned() {
    //   return this.users.filter((u) => u.banned);
    // },
  },
  methods: {
    enableFor(arr) {
      if (!this.$user.data.role) return false;
      return arr.includes(this.$user.data.role[0])
    },
    openModal(user) {
      this.userSelected = user;
      this.modalDriver = true

      // if(user.role[0] === 'driver') {
      //   this.modalDriver = true
      // } else {
      //   if(this.disableFor(['hr']))
      //    this.modalUser = true
      // }
    },
    switchBirthday() {
      this.showBirthday = !this.showBirthday;
      let arr = [];
      if (this.showBirthday) {
        arr = this.users;
        this.users = [...this.userBirthday];
        this.userBirthday = [...arr];
      } else {
        arr = this.userBirthday;
        this.userBirthday = [...this.users];
        this.users = [...arr];
      }
      this.arrayList = this.paginator(this.users, 1, this.tableLenght);
    },
    switchBanned() {
      this.showBanned = !this.showBanned;
      let arr = [];
      if (this.showBanned) {
        arr = this.users;
        this.users = [...this.banned];
        this.banned = [...arr];
      } else {
        arr = this.banned;
        this.banned = [...this.users];
        this.users = [...arr];
      }
      this.arrayList = this.paginator(this.users, 1, this.tableLenght);
    },
    // clearSearch() {
    //   return this.clearInput;
    //   // for (let [key, value] of Object.entries(this.search)) {
    //   //
    //   //   if(value !== "") {
    //   //     // filter[key] = value[key];
    //   //     console.log("key if")
    //   //   } else {
    //   //     return this.users;
    //   //
    //   //     console.log("key else")
    //   //   }
    //   // }
    // },
    // inputChange() {
    //   // for (let [key, value] of Object.entries(this.search)) {
    //   //   if(value.length > 0) {
    //   //     // console.log("if", key, value.length)
    //   //   } else {
    //   //     // console.log("else", key, value.length)
    //   //   }
    //   // }
    //   // console.log("this.arrayFiltered 2222", this.arrayFiltered )
    // },
    copy(user) {
      this.loading = true
      try {
        let iban = user.iban || "-";
        let name = (user.firstName + ' ' + user.secondName) || "-";
        const toCopy = name + ' - ' + iban;
        //await navigator.clipboard.writeText(toCopy);
        this.$copyText(toCopy).then(
          function (e) {
            //alert('Copied')
            setTimeout(() => { this.loading = false }, 1000)
            // console.log(e)
          },
          function (e) {
            //alert('Can not copy')
            setTimeout(() => { this.loading = false }, 1000)
            // console.log(e)
          }
        );

        toastr["success"](this.$t("monitor.textCopied"));
      } catch (err) {
        console.error("Failed to copy: ", err);
        setTimeout(() => { this.loading = false }, 1000)
      }
    },
    async getUsers() {
      this.loading = true
      let response = await this.$http.get("/user");
      console.log(response)
      setTimeout(() => { this.loading = false }, 1000)
      let users = response.data.users;
      this.banned = users.filter((u) => u.banned);
      users = users.filter((u) => !u.banned);
      users = users.filter((u) => u.role[0] !== 'super');
      this.array = this.generateData(users);
      this.userBirthday = this.users.filter(user => user.soonBirthday === "show");
      this.arrayList = this.paginator(this.array, 1, this.tableLenght);

    },
    generateData(data) {
      this.loading = true
      const isBirthday = (m1, m2) => {
        return m1.date() === m2.date() && m1.month() === m2.month();
      }

      data.forEach(user => {
        user.roleSearch = user.role.map(item => this.$t('roles.' + item)).join(' ');
        user.birthday = user.birthday ? this.$moment(user.birthday).format('YYYY-MM-DDTHH:mm:ssZ') : '';
        user.dismissal = user.dismissal ? this.$moment(user.dismissal).format('YYYY-MM-DDTHH:mm:ssZ') : '';
        user.recruitingDate = user.recruitingDate ? this.$moment(user.recruitingDate).format('YYYY-MM-DDTHH:mm:ssZ') : '';
        user.visaExpiry = user.visaExpiry ? this.$moment(user.visaExpiry).format('YYYY-MM-DDTHH:mm:ssZ') : '';
        user.phoneSearch = user.phone ? user.phone.join(' ') + user.personalPhone.join(' ') : '';
        user.clubSearch = user.clubId ? user.clubId.name : ''
        user.soonExpire = false;
        if (user.visaExpiry) {
          let eventdate = this.$moment(user.visaExpiry);
          let todaysdate = this.$moment();
          if (eventdate.diff(todaysdate, 'days') <= 30) {
            user.soonExpire = true;
          }
        }
        user.soonBirthday = 'no';
        user.whenBirthday = null;
        if (user.birthday) {
          let today = this.$moment();
          let tomorrow = this.$moment().add(1, 'days');
          if (isBirthday(today, this.$moment(user.birthday))) {
            user.soonBirthday = 'show';
            user.whenBirthday = 'today';
          }
          else if (isBirthday(tomorrow, this.$moment(user.birthday))) {
            user.soonBirthday = 'show';
            user.whenBirthday = 'tomorrow';
          }

        }
        user.visaExpiryDisplay = user.visaExpiry ? this.$moment(user.visaExpiry).format('DD.MM.YYYY') : '';
      });
      setTimeout(() => { this.loading = false }, 1000)
      // console.log(data)
      return data;
    }
  },
  async mounted() {
    await this.getUsers();
  }
}
</script>
<style scoped>
.bracket-custom-style .ivu-spin {
  background: #454751 !important;
  color: #ffffff;
}

.users-table-view :global(.ivu-avatar) {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.users-table-view .header-card {
  background: var(--bg-darkness);
  color: var(--text-color);
}

.users-table-view .page-title {
  font-size: 24px;
  font-weight: 600;
}

.users-table-view .table-striped tbody tr:nth-of-type(odd) {
  background-color: #e8e8e8;
}

.users-table-view :global(.ivu-select-selection .ivu-select-placeholder) {
  color: #495057;
}

.users-table-view .table tbody tr:hover,
.users-table-view .table-striped tbody tr:nth-of-type(odd):hover {
  background: #d3d3d3;
}

.user-info-btn {
  padding: 0 10px;
  line-height: 1;
}

#users-table tr th,
#users-table tr td {
  padding: 4px;
  font-size: 13px;
}

#users-table {
  border-collapse: inherit;
  border-spacing: 0;
  width: inherit;
  contain: unset;
  table-layout: fixed;
  margin: 0 auto;
}

.users-table-view .card-body-table {
  overflow-x: scroll;
  height: calc(100vh - 275px);
  padding: 0;
}

.card-body-table .expire {
  background: #ff000047;
}

.card-body-table .todayBirthday {
  background: #8fbc8f75;
}

.card-body-table .tomorrowBirthday {
  background: #ffff0042;
}

#users-table :global(.ivu-tooltip-rel) {
  cursor: pointer;
}

/*.sort-by {*/
/*  display: inline-block;*/
/*  float: right;*/
/*  cursor: pointer;*/
/*}*/

.user-info-btn {
  padding: 5px 10px;
}

#users-table td.user-style :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  vertical-align: middle;
}


#users-table td.user-style :global(.ivu-tooltip) {
  width: 205px;
}

#users-table td.user-iban-style :global(.ivu-tooltip) {
  width: 180px;
}

#users-table tr td {
  font-size: 14px !important;
  line-height: 15px;
}

#users-table tr td,
#users-table tr th {
  vertical-align: middle;
  position: relative;
}

#users-table td.user-phone-list :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  max-height: 32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

#users-table td.user-phone-list :global(.ivu-tooltip) {
  width: 129px;
}

.badge-soft-primary {
  background-color: #dbe1f7 !important;
}

.good-rating {
  color: #18BE6B;
}

.average-rating {
  color: #FF9A01;
}

.black-list-rating {
  color: #EE4014;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before) {
  color: #18BE6B;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before),
.md-checkmark-style :global(.ivu-icon-md-checkmark-circle-outline:before) {
  line-height: 1;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UsersTable.vue